const PORTAL_TYPE = {
    CLIENT: 'client',
    EMPLOYEE: 'employee'
}

export default PORTAL_TYPE;